export default __webpack_public_path__ + "static/media/qs-icon.451b423e.webp";